import React from 'react';
import { OfferBar } from './components/OfferBar';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Steps } from './components/Steps';
import { FAQ } from './components/FAQ';
import { ValueStack } from './components/ValueStack';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-full w-full overflow-x-hidden text-plum" data-id="element-0" data-mp="31cjou2jzrr2f">
      <MetaPixel data-id="element-1" data-mp="2wifgpfyzpczr" />
      <OfferBar data-id="element-2" data-mp="2whxbhtucnofp" />
      {/* Spacer matching the fixed offer bar height */}
      <div className="h-[58px] sm:h-[68px]" aria-hidden="true" style={{
      paddingBottom: "29px"
    }} data-id="element-3" data-mp="28suu8n3mnxlq" />
      <main data-id="element-4" data-mp="23utcq6luo6cd">
        <Hero data-id="element-5" data-mp="23v2tr4ox335x" />
        <Stats data-id="element-6" data-mp="23ti7s3go4sjo" />
        <Testimonials data-id="element-7" data-mp="3ik7gihlkcdr6" />
        <PainPoints data-id="element-8" data-mp="3ikqz80j1f669" />
        <Volumes data-id="element-9" data-mp="3ij61k21ff746" />
        <Bonuses data-id="element-10" data-mp="3ijpef4c7z5bc" />
        <Pricing data-id="element-11" data-mp="3ii4ppvcl6gle" />
        <Steps data-id="element-12" data-mp="3mlatmwc87vop" />
        <FAQ data-id="element-13" data-mp="3mkrcviybbdc9" />
        <ValueStack data-id="element-14" data-mp="3mk868ye44bdj" />
      </main>
      <Footer data-id="element-15" data-mp="3mjgczu7zmpqf" />
    </div>;
}